import { ConfigProvider } from "antd";
import React, { useContext, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { isAuthenticated } from "../helpers/utility";
import {
  customLightTheme,
  DEFAULT_PRIMARY_ACTIVE,
  DEFAULT_PRIMARY_COLOR,
  DEFAULT_PRIMARY_HOVER,
} from "../theme/customTheme";

const PrivateRoute = () => {
  const { userDetails } = useContext(UserContext);

  function reduceOpacity(hex, opacity) {
    const value = (hex || DEFAULT_PRIMARY_COLOR).replace("#", "");
    if (value.length !== 6) {
      return DEFAULT_PRIMARY_HOVER;
    }
    const r = parseInt(value.substring(0, 2), 16);
    const g = parseInt(value.substring(2, 4), 16);
    const b = parseInt(value.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  const resolvedPrimary = userDetails?.activeOrg?.color || DEFAULT_PRIMARY_COLOR;

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--ant-primary-color",
      resolvedPrimary
    );
  }, [resolvedPrimary]);

  const customTheme = {
    ...customLightTheme,
    token: {
      ...customLightTheme.token,
      colorPrimary: resolvedPrimary,
    },
    components: {
      ...customLightTheme.components,
      Button: {
        ...customLightTheme.components.Button,
        colorPrimaryHover:
          reduceOpacity(resolvedPrimary, 0.9) || DEFAULT_PRIMARY_HOVER,
        colorPrimaryActive: resolvedPrimary || DEFAULT_PRIMARY_ACTIVE,
      },
      Input: {
        ...customLightTheme.components.Input,
        colorPrimaryHover: resolvedPrimary,
      },
    },
  };
  return isAuthenticated && isAuthenticated() ? (
    <ConfigProvider theme={customTheme}>
      <Outlet />
    </ConfigProvider>
  ) : (
    <Navigate to="/" />
  );
};

export default PrivateRoute;
